import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import InternalHeader from "./InternalHeader";
import InternalFilter from "./InternalFilter";
import InternalCommonSection from "./CommonSection/InternalCommonSection";
import { useSelector, useDispatch } from "react-redux";
import ViewSummary from "../ViewSummary/ViewSummary";
import {
  setCountry,
  setFlashColor,
  setInternalPageHeader,
  setIpOwnerShip,
  setSearch,
  setSector,
  setVariety,
} from "../../slices/internalPageSlice";
import NoRecordFounds from "../../utils/NoRecordsFound";

export default function InternalPageLayout({
  pageData,
  header,
  showDropdown = true,
  slug,
  nodata,
  cardButtonDisable,
}) {
  const selectedView = useSelector((state) => state.view);
  const [grid, setGrid] = useState(selectedView);
  const [selectedSection, setSelectedSection] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    setGrid(selectedView);
    dispatch(setInternalPageHeader(header));
  }, [selectedView]);
  useEffect(() => {
    dispatch(setSector(""));
    dispatch(setSearch(""));
    dispatch(setCountry(""));
    dispatch(setVariety(""));
    dispatch(setFlashColor(""));
    dispatch(setIpOwnerShip(""));
  }, []);
  const { viewSummaryDrawer } = useSelector((store) => store.viewSummary);

  return (
    <Box
      sx={{
        mt: "24px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        mb: "24px",
        paddingX: { xs: "16px", md: "53px" },
      }}
    >
      <InternalHeader header={header} />

      <Box sx={{ zIndex: 1000 }}>
        <InternalFilter
          setGrid={setGrid}
          pageData={pageData}
          header={header}
          grid={grid}
          setSelection={setSelectedSection}
          showDropdown={showDropdown}
          nodata={nodata}
        />
      </Box>
      {nodata ? (
        <NoRecordFounds text={false} />
      ) : (
        pageData?.internalPageSections?.length > 0 &&
        (pageData?.internalPageSections || [])?.map((section, index) => {
          return (
            <InternalCommonSection
              data={section}
              key={section?.sectionId}
              grid={grid}
              selectedSection={selectedSection}
              setGrid={setGrid}
              subPageId={section?.sectionId}
              slug={slug}
              cardButtonDisable={cardButtonDisable}
            />
          );
        })
      )}
      {viewSummaryDrawer && <ViewSummary />}
    </Box>
  );
}

InternalPageLayout.propTypes = {
  pageData: PropTypes.shape({
    internalSubPages: PropTypes.objectOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string,
        content: PropTypes.string,
      })
    ),
  }),
  header: PropTypes.string.isRequired,
};
